import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'lex-last-run-review-dialog',
    templateUrl: './last-run-review-dialog.component.html',
    styleUrls: ['./last-run-review-dialog.component.scss'],
    standalone: false
})
export class LastRunReviewDialogComponent {
	constructor(private dialogRef: MatDialogRef<LastRunReviewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: string) { }
	public close() { this.dialogRef.close(); }
}
